import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import {disabledLight} from '../themes/colors';

class Svg extends Component {
    render() {
        const {children, containerStyle, iconStyle, color, viewBox, className, onClick, id, disabled} = this.props;
        return <div style={containerStyle} className={className} onClick={onClick} id={id}>
            <SvgIcon
                style={iconStyle || containerStyle} nativeColor={!disabled ? color : disabledLight} viewBox={viewBox}>
                {children}
            </SvgIcon>
        </div>;
    }
}

Svg.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
    containerStyle: PropTypes.object,
    iconStyle: PropTypes.object,
    color: PropTypes.string,
    viewBox: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default Svg;
